export interface HnswIndexStatus {
  status: "ok" | "missing" | "error";
  present: string[];
  missing: string[];
  detail?: string;
}

function isStringList(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((item) => typeof item === "string");
}

/** A resolved HTTP request can still contain a proxy or database error body. */
export function normalizeHnswIndexStatus(
  body: unknown,
  httpStatus: number,
): HnswIndexStatus {
  const error: HnswIndexStatus = { status: "error", present: [], missing: [] };
  if (!body || typeof body !== "object" || Array.isArray(body)) return error;
  const data = body as Record<string, unknown>;
  if (data.status === "error" && typeof data.detail === "string") {
    error.detail = data.detail;
  }
  // Older backends report a verified missing-index list with HTTP 503.
  if ((httpStatus < 200 || httpStatus >= 300)
    && !(httpStatus === 503 && data.status === "missing")) return error;
  if (data.status === "ok") {
    return {
      status: "ok",
      present: isStringList(data.present) ? data.present : [],
      missing: [],
    };
  }
  if (data.status === "missing" && isStringList(data.missing) && data.missing.length > 0) {
    return {
      status: "missing",
      present: isStringList(data.present) ? data.present : [],
      missing: data.missing,
    };
  }
  return error;
}